module.exports = "//static.hsappstatic.net/marketplace-assets-base/static-1.6703/img/business-types/food-beverage.png"